module.exports = __webpack_public_path__ + "img/pantalla-4-3.678fa8ad.png";